export default __webpack_public_path__ + "static/media/visa-ico.c12b2263.svg";